const data = {
	"width": 24,
	"height": 24,
	"body": "<path fill=\"currentColor\" d=\"m12 8l6 6H6z\"/>"
};
export default data;
